import React, { useEffect } from 'react';
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import HomemadeDogFoodForAllergies from "./pages/HomemadeDogFoodForAllergies";
import About from "./pages/about";
import Recipes from "./pages/recipes";
import RecipeDetail from "./pages/RecipeDetail";
import CustomRecipeWizard from './pages/CustomRecipeWizard';
import RecipeBuilder from './pages/RecipeBuilder';
import { Layout } from 'antd';
import './App.css';
import NavigationMenu from "./components/VerticalMenu"
import AppFooter from "./components/AppFooter";
import FoodToAvoid from './pages/foodToAvoid';
import Tips from './pages/tips';
import HowRecipesAreDeveloped from './pages/HowRecipesAreDeveloped';
import TransitionGuide from './pages/TransitionGuide';
import FeedingPortions from './pages/FeedingPortions';
import Supplements from './pages/supplements';
import ScrollToTop from "./components/ScrollToTop";
import { AuthProvider } from './auth/AuthContext';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Confirmed from './pages/Confirmed';
import ConfirmationError from './pages/ConfirmationError';
import Profile from './pages/Profile';
import Settings from './pages/Settings';
import Pricing from './pages/Pricing';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import WelcomeBanner from './components/WelcomeBanner';
const { Header, Content } = Layout;

const App: React.FC = () => {

  // const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      // setLoading(false);
    }, 2000); // Simulates loading
  }, []);


  // TODO fix this loading skeleton 
  return (
    <AuthProvider>
    <Layout className="app-layout">
    {/* <Skeleton loading={loading} active>
      <h3>Title loaded</h3>
      <p>Content has loaded successfully.</p>
    </Skeleton> */}
    <Header className="header">
      <NavigationMenu></NavigationMenu>
    </Header>
    <WelcomeBanner />
    <Content className="content">
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} /> {/* Ensures '/' is handled if they dont have home in the url*/}
        <Route path="/home" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/confirmed" element={<Confirmed />} />
        <Route path="/users/confirmation" element={<Confirmed />} />
        <Route path="/confirmation-error" element={<ConfirmationError />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/recipes" element={<Recipes />} />
        <Route path="/recipes/:slug" element={<RecipeDetail />} />
        <Route path="/about" element={<About />} />
        <Route path="/supplements" element={<Supplements />} />
        <Route path="/food-to-avoid" element={<FoodToAvoid />} />
        <Route path="/custom-recipes" element={<CustomRecipeWizard />} />
        <Route path="/recipe-builder" element={<RecipeBuilder />} />
        <Route path="/recipe-builder/details" element={<RecipeBuilder />} />
        <Route path="/recipe-builder/results" element={<RecipeBuilder />} />
        <Route path="/tips" element={<Tips />} />
        <Route path="/feeding-portions" element={<FeedingPortions />} />
        <Route path="/how-recipes-are-developed" element={<HowRecipesAreDeveloped />} />
        <Route path="/homemade-dog-food-for-allergies" element={<HomemadeDogFoodForAllergies />} />
        <Route path="/transition-guide" element={<TransitionGuide />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
      </Routes>
    </Content>
    <AppFooter />
    </Layout>
    </AuthProvider>
  );
};

export default App;